import { merge } from 'lodash';
import { WidgetType } from './types';

type DefaultValues = {
  dataLimit: number;
  loaderSize: 'small' | 'default' | 'large';
  useCardLoading: boolean;
  wrapInCard: boolean;
  showFooter: boolean;
  cardProps: any;
  size: {
    width: number;
    height: number;
  };
};

function getDefaults(type: WidgetType) {
  const defaultVal: DefaultValues = {
    dataLimit: 10,
    loaderSize: 'default',
    useCardLoading: true,
    wrapInCard: true,
    showFooter: false,
    cardProps: {},
    size: { width: 8, height: 7 }, // Grid layout size
  };

  switch (type) {
    case 'STATS_VALUE':
      return merge(defaultVal, {
        dataLimit: 1,
        size: { height: 5 },
      });
    case 'BAR_GRAPH':
    case 'LINE_GRAPH':
    case 'MIXED_GRAPH':
    case 'FUNNEL_GRAPH':
      return merge(defaultVal, {
        dataLimit: 31,
        loader: 'string',
        showFooter: true,
        size: { width: 24, height: 13 },
      });
    case 'PIE_CHART':
      return merge(defaultVal, {
        dataLimit: 5,
        loaderSize: 'large',
        showFooter: true,
        size: { width: 12, height: 10 },
      });
    case 'STATS_TABLE':
      return merge(defaultVal, {
        useCardLoading: false,
        showFooter: true,
        cardProps: { bodyStyle: { padding: '1px 0 0' } },
        size: { width: 12, height: 8 },
      });
    default:
      return defaultVal;
  }
}

function shouldFetchData(widgetType: WidgetType, sums: string[], groups: string[]) {
  switch (widgetType) {
    case 'FUNNEL_GRAPH':
    case 'STATS_VALUE':
      return Boolean(sums.length);
    default:
      return Boolean(sums.length && groups.length);
  }
}

export { getDefaults, shouldFetchData };
